<template>
  <custom-modal
    :visible.sync="visible"
    title="企业品牌形象设置"
    width="480px"
    :loading="loading"
    @submit="handleSubmit"
    @closed="handleClosed">
    <el-table
      border
      max-height="600px"
      :data="list">
      <el-table-column
        label="品牌形象"
        min-width="200"
        prop="name">
        <template slot-scope="{ row }">
          <el-input
            v-model.trim="row.name"
            maxlength="4"
            show-word-limit></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="60">
        <template slot-scope="{ $index }">
          <el-button
            type="text"
            @click="deleteRow($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      style="width: 100%;margin: 10px 0 0"
      type="primary"
      size="mini"
      :loading="loading"
      @click="addRow">添加品牌形象</el-button>
  </custom-modal>
</template>
<script>
import CustomModal from '@/components-v2/custom-modal.vue'
import { modalMixin } from '../mixin'
export default {
  name: 'CompanyBrandImageModal',
  components: { CustomModal },
  mixins: [modalMixin],
  data() {
    return { visible: false, loading: false, list: [] }
  },
  methods: {
    onSuccess(v) {
      this.list = JSON.parse(v).map(name => ({ name }))
    },
    onNotInited() {
      this.addRow()
    },
    handleClosed() {
      this.visible = false
      this.list = []
    },
    handleSubmit() {
      if (this.list.every(i => !!i.name)) {
        this.loading = true
        this.$$examApi.setkeyvalue({ ...this.config, v: JSON.stringify(this.list.map(i => i.name)) })
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('保存成功')
              this.init(this.config)
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      } else {
        this.$message.error('请填写完整的品牌形象')
      }
    },
    addRow() {
      this.list.push({ name: '' })
    },
    deleteRow(index) {
      this.list.splice(index, 1)
    }
  }
}
</script>
